<template>
  <div
    id="home"
    class=""
  >
    <!-- 视频 -->
    <div
      id="id-home-bg"
      class="home-bg"
      :style="bgStyle"
    >
      <!-- 播放按钮图 -->
      <img
        src="../assets/images/play.png"
        class="home-play-btn"
      />
      <!-- 播放按钮的遮罩 -->
      <div
        class="home-play-hexagon"
        @click="showVideo = true"
      ></div>

      <!-- 标题、副标题 -->
      <!-- 公告跳转框 和标题放一起，省事儿 -->
      <div class="title">
        <img
          :src="mainTitle"
          class="title-main"
          :style="newMainTitleStyle"
        />
        <img
          :src="subTitle"
          class="title-sub"
          :style="newSubTitleStyle"
        />
        <div class="title-anno">
          <!-- left -->
          <div class="title-anno-left">
            <span class="title-anno-left-icon">
              <img src="../assets/images/202603/nav-anno/icon2.png">
            </span>
            <span class="title-anno-left-text">
              {{ $t("announcement.publishTime") }}
            </span>
          </div>
          <!-- middle -->
          <div class="title-anno-middle">
            <div class="title-anno-middle-scroll">
              <span class="title-anno-middle-scroll-text">
                <router-link
                  to="/announcement"
                  class="title-anno-link"
                >
                  {{ $t("announcement.title") }}
                </router-link>
              </span>
            </div>
          </div>
          <!-- right -->
          <div class="title-anno-right">
            <router-link
              to="/announcement"
              class="title-anno-link"
            >
              <span class="title-anno-right-text">查看更多</span>
              <div class="title-anno-right-icon">
                <img src="../assets/images/202603/nav-anno/arrow.png">
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- 下载按钮 -->
      <div class="shop">
        <template v-for="link, idx in links[this.$i18n.locale]">
          <a
            v-if="!link.isModal"
            :key="'link-' + idx"
            :href="link.href"
            target="_blank"
          >
            <img
              :src="link.icon"
              class="shop-img"
            />
          </a>
          <img
            v-else
            :key="'modal-' + idx"
            :src="link.icon"
            class="shop-img shop-modal-trigger"
            @click="showMoreModal = true"
          />
        </template>
      </div>
    </div>

    <!-- HomeVideo -->
    <div
      class="video-modal"
      v-if="showVideo"
    >
      <div
        class="modal-mask"
        @click="closeVideo"
      ></div>
      <div class="modal-content">
        <video
          id="id-homevideo"
          ref="videoPlayer"
          :src="getHomeVideoUrl"
          controls
          autoplay
          loop
          volume="0.5"
          class="modal-video"
        ></video>
      </div>
    </div>

    <!-- More Modal -->
    <div
      class="more-modal"
      v-if="showMoreModal"
    >
      <div
        class="more-modal-mask"
        @click="closeMoreModal"
      ></div>
      <div class="more-modal-content">
        <img
          :src="moreModalBg"
          class="more-modal-bg"
        />
        <h3 class="more-modal-title">其他下载</h3>
        <img
          src="../assets/images/20260424/zh/more/btn-close.png"
          class="more-modal-close"
          @click="closeMoreModal"
        />
        <div class="more-modal-body">
          <div class="more-platform-section">
            <h3 class="more-platform-title">PC 平台</h3>
            <div class="more-platform-grid">
              <a
                v-for="platform in pcPlatforms"
                :key="platform.name"
                :href="platform.href"
                target="_blank"
                class="more-platform-link"
              >
                <img
                  :src="platform.icon"
                  class="more-platform-img"
                  :alt="platform.name"
                />
              </a>
            </div>
          </div>
          <div class="more-platform-section">
            <h3 class="more-platform-title">手机平台</h3>
            <div class="more-platform-grid">
              <a
                v-for="platform in mobilePlatforms"
                :key="platform.name"
                :href="platform.href"
                target="_blank"
                class="more-platform-link"
              >
                <img
                  :src="platform.icon"
                  class="more-platform-img"
                  :alt="platform.name"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 审查 censor -->
    <div class="censor">
      <img
        v-show="this.$i18n.locale == 'zh'"
        src="../assets/images/202510/home/censor/zh.png"
        class="censor-img"
      />
      <img
        v-show="this.$i18n.locale == 'en'"
        src="../assets/images/202510/home/censor/en.png"
        class="censor-img"
      />
      <img
        v-show="this.$i18n.locale == 'en'"
        src="../assets/images/202510/home/censor/en1.png"
        class="censor-img2"
      />
      <img
        v-show="this.$i18n.locale == 'ja'"
        src="../assets/images/202510/home/censor/ja-new.svg"
        class="censor-img"
      />
    </div>

    <div class="logo">
      <img
        src="../assets/images/202510/home/censor/logo.png"
        class="logo-img"
      />
    </div>

    <div class="copyright-info">
      <span>© ARC SYSTEM WORKS / © 91Act. Developed by 91Act. Published by Astrolabe Games & 91Act. All rights reserved.</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 定时更换背景图
      switchTime: "2026-02-12 00:00:00",
      oldBgUrl: require("../assets/images/202510/home/bg.png"),
      newBgUrl: require("../assets/images/202602/home/bg.png"),
      timer: null,
      hasSwitched: false,
      // 视频弹窗
      showVideo: false,
      // More弹窗
      showMoreModal: false,
      moreModalBg: require("../assets/images/20260424/zh/more/bg-modal.png"),
      pcPlatforms: [
        { icon: require("../assets/images/20260424/zh/more/wegame.png"), name: "wegame", href: "https://www.wegame.com.cn/store/2002138/" },
        { icon: require("../assets/images/20260424/zh/more/steam-china.png"), name: "steam-china", href: "https://store.steamchina.com/app/2273430/" }
      ],
      mobilePlatforms: [
        { icon: require("../assets/images/20260424/zh/more/android.png"), name: "android", href: "https://acecn-mobile-volc-pkg-cdn.91act.com/bbee/bbee.apk" },
        { icon: require("../assets/images/20260424/zh/more/iso.png"), name: "ios", href: "https://apps.apple.com/cn/app/id6497877633" },
        { icon: require("../assets/images/20260424/zh/more/taptap.png"), name: "taptap", href: "https://www.taptap.cn/app/233514" },
        { icon: require("../assets/images/20260424/zh/more/bilibil.png"), name: "bilibili", href: "https://www.biligame.com/detail/?id=108826&spm_id_from=555.224.0.0&sourceFrom=1600820011" },
        { icon: require("../assets/images/20260424/zh/more/huawei.png"), name: "huawei", href: "https://appgallery.huawei.com/app/C111687743" },
        { icon: require("../assets/images/20260424/zh/more/harmonyos.png"), name: "harmonyos", href: "https://game.cloud.huawei.com/gc/link/detail?appId=C5765880207854395317&shareFrom=button" },
        { icon: require("../assets/images/20260424/zh/more/haoyou.png"), name: "haoyou", href: "https://www.3839.com/a/142950.htm" },
        { icon: require("../assets/images/20260424/zh/more/4399.png"), name: "4399", href: "https://a.4399.cn/game-id-234182.html" }
      ],
      links: {
        zh: [
          { icon: require(`../assets/images/20260424/zh/base/ps.png`), href: "https://store.playstation.com/zh-hans-hk/concept/10013958" },
          { icon: require(`../assets/images/20260424/zh/base/ns.png`), href: "https://ec.nintendo.com/HK/zh/titles/70010000105929" },
          { icon: require(`../assets/images/20260424/zh/base/ms-xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" },
          { icon: require(`../assets/images/20260424/zh/base/steam.png`), href: "https://store.steampowered.com/app/2273430" },
          { icon: require(`../assets/images/20260424/zh/base/taptap-pc.png`), href: "https://www.taptap.cn/app/233514?os=pc" },
          { icon: require(`../assets/images/20260424/zh/base/more.png`), isModal: true },
        ],
        en: [
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/en-us/concept/10013958" },
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ns.png`), href: "https://www.nintendo.com/us/store/products/blazblue-entropy-effect-x-switch/" },
          { icon: require(`../assets/images/202602/shop/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" }
        ],
        ja: [
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/ja-jp/concept/10013958" },
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ns.png`), href: "https://store-jp.nintendo.com/item/software/D70010000105928" },
          { icon: require(`../assets/images/202602/shop/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" }
        ]
      }
    }
  },
  methods: {
    closeVideo() {
      this.showVideo = false
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause()
      }
    },
    closeMoreModal() {
      this.showMoreModal = false
    },
    getTimeDiff() {
      // 目标时间
      const targetTime = new Date(this.switchTime).getTime()
      // 当前时间
      const nowTime = new Date().getTime()
      return targetTime - nowTime
    },
    initBgSwitchTimer() {
      const timeDiff = this.getTimeDiff()

      // 4. 判断是否需要设置定时器
      if (timeDiff <= 0) {
        // 如果当前时间已过指定时间，直接切换
        this.switchBgAndTitle()
      } else {
        // 否则设置单次定时器，到点后切换
        this.timer = setTimeout(() => {
          this.switchBgAndTitle()
        }, timeDiff)
      }
    },
    switchBgAndTitle() {
      if (!this.hasSwitched) {
        this.hasSwitched = true
      }
    }
  },
  computed: {
    timeDiff() {
      const targetTime = new Date(this.switchTime).getTime()
      const nowTime = new Date().getTime()
      return targetTime - nowTime
    },
    bgStyle() {
      return {
        background: `url("${this.hasSwitched ? this.newBgUrl : this.oldBgUrl}") no-repeat center center / cover`,
        width: "100%",
        height: "100%"
      }
    },
    // showVideoBtn() {
    //   return this.hasSwitched
    //     ? {
    //       display: "none",
    //     }
    //     : ""
    // },
    newMainTitleStyle() {
      return this.hasSwitched
        ? {
          position: "absolute",
          // 核心修改：用vw替代固定px，height:auto保持宽高比
          // width: "36.5vw", // 584px 对应 1920px 视口的 36.5vw（584/1920≈0.365）
          maxWidth: "500px", // 限制最大宽度，避免大屏下过大
          height: "auto", // 自动计算高度，保持图片原始宽高比
          bottom: "12.5vw", // 底部距离也改用vw，适配不同视口
          left: "50%", // 可选：居中对齐（如果需要）
          transform: "translateX(-50%)" // 可选：配合left:50%实现水平居中
        }
        : ""
    },
    newSubTitleStyle() {
      return this.hasSwitched
        ? {
          position: "absolute",
          // 同理：根据subTitle的原始尺寸换算vw，示例值请根据实际调整
          // width: "28vw",
          // maxWidth: "450px", // 替换为subTitle的最大宽度
          height: "auto",
          maxWidth: "500px",
          bottom: "9vw", // 适配底部距离
          left: "50%",
          transform: "translateX(-50%)"
        }
        : ""
    },
    mainTitle() {
      const locale = this.$i18n.locale
      return this.hasSwitched
        ? require(`../assets/images/202602/title/${locale}/main.png`)
        : require(`../assets/images/202510/home/title/${locale}/main.png`)
    },
    subTitle() {
      const locale = this.$i18n.locale
      return this.hasSwitched
        ? require(`../assets/images/202602/title/${locale}/sub.png`)
        : require(`../assets/images/202510/home/title/${locale}/sub.png`)
    },
    getHomeVideoUrl() {
      return `https://bbeex.91act.com/videos/pv-aio-${this.$i18n.locale}.webm`
    }
  },
  mounted() {
    this.initBgSwitchTimer()
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
</script>

<style scoped lang="scss">
#home {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 99;
}

.home-bg {
  width: 100%;
  height: 100%;
}

.home-play-btn {
  width: 480px;
  height: 104px;
  position: absolute;
  left: 50%;
  top: calc(50% - 120px);
  transform: translateX(-49%) scale(0.85) translate(0.5rem, 0.5rem);
  z-index: 100;
}

.home-play-hexagon {
  width: 95px;
  height: 83px;
  position: absolute;
  left: 50%;
  top: calc(50% - 110px);
  transform: translateX(-45%) translate(0.5rem, 0.5rem);
  clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%, 25% 0%);
  z-index: 101;
  cursor: pointer;
}

.video-modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.modal-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  position: absolute;
  z-index: 1001;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-video {
  max-width: 1024px;
  max-height: 720px;
}

.more-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
}

.more-modal-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.more-modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2001;
}

.more-modal-bg {
  width: 600px;
  height: auto;
}

.more-modal-title {
  position: absolute;
  top: 1.75rem;
  left: 5rem;
  color: #ffffff;
  font-size: 20px;
  font-family: "MiSans-Medium";
  padding-top: 10px;
}

.more-modal-close {
  position: absolute;
  top: 2rem;
  right: 2rem;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 2002;
}

.more-modal-body {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 100%;
  padding-top: 6rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  box-sizing: border-box;
  overflow-y: auto;
}

.more-platform-section {
  margin-bottom: 64px;
}

.more-platform-section:last-child {
  margin-bottom: 0;
}

.more-platform-title {
  color: #ffffff;
  font-size: 16px;
  font-family: "MiSans-Medium";
  padding-top: 10px;
}

.more-platform-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 8px;
  margin-bottom: 20px;
}

.more-platform-link {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s;
  overflow: hidden;
}

.more-platform-link:hover {
  transform: scale(1.05);
}

.more-platform-img {
  width: 100%;
  height: auto;
  max-width: 160px;
  max-height: 80px;
  object-fit: contain;
}

.title {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  left: 50%;
  transform: translateX(-50%);
  bottom: 36px;
}

.title-main {
  position: absolute;
  width: 1014px;
  height: 188px;
  bottom: 21%;
}

.title-sub {
  position: absolute;
  width: 1145px;
  height: 43px;
  bottom: 18%;
}

.title-anno {
  display: flex;
  position: absolute;
  justify-content: center;
  bottom: 10.25rem;
  width: 600px;
  height: 35px;
  background-image: url("../assets/images/202603/nav-anno/bg.png");
  background-repeat: no-repeat;
  background-size: 100%;
}

.title-anno-link {
  color: red;
  font-family: "MiSans-Medium";
  cursor: pointer;
  text-decoration: none;
}

.title-anno-left {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 22%;
  position: absolute;
  left: 0;
}

.title-anno-left-icon {
  height: 100%;
  width: 1.3125rem;
  left: 0;
  margin: 0 0.5rem;
  align-items: center;
  justify-content: center;
  position: absolute;
  display: flex;

  > img {
    height: 18px;
    width: 21px;
  }
}

.title-anno-left-text {
  font-family: "MiSans-Medium";
  color: red;
  cursor: default;
  display: flex;
  position: absolute;
  right: 0;
  width: calc(100% - 35px);
  justify-content: space-between;
  align-items: center;
}

.title-anno-middle {
  flex: 1;
  height: 100%;
  width: 60%;
  left: 22%;
  overflow: hidden;
  position: absolute;
  margin: 0 0.25rem;
  justify-content: center;
  align-items: center;
  display: flex;
}

.title-anno-middle-scroll {
  position: absolute;
  white-space: nowrap;
  color: red;
  font-family: "MiSans-Medium";
  line-height: 100%;
  cursor: pointer;
  width: 100%;
  display: flex;
  animation: none;
}

.title-anno-middle-scroll-text {
  animation: scroll-left 15s linear infinite;
  justify-content: center;
  align-items: center;
}

@keyframes scroll-left {
  0% {
    /* 初始位置：左对齐 */
    transform: translateX(0);
  }

  20% {
    /* 延迟结束，开始滚动 */
    transform: translateX(0);
  }

  100% {
    /* 最后10%时长回到右侧外（准备下一轮） */
    transform: translateX(-100%);
  }
}

.title-anno-right {
  right: 0;
  width: 16%;
  height: 100%;
  margin: 0 8px;
  display: flex;
  position: absolute;
  cursor: pointer;
}

.title-anno-right-text {
  display: flex;
  position: absolute;
  height: 100%;
  justify-content: center;
  align-items: center;
  font-family: "MiSans-Medium";
  color: #888888;
  margin: 0 8px;
}

.title-anno-right-icon {
  height: 100%;
  width: 1.4375rem;
  right: 0;
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;

  > img {
    height: 0.9375rem;
    width: 1.4375rem;
  }
}

.shop {
  position: absolute;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  width: 600px;
  justify-content: center;
  align-items: center;
  gap: 0;
  bottom: 0;
  transform: translateY(-35%);
  z-index: 300;
  left: 50%;
  margin-left: -296px;
}

.shop > * {
  margin: -4px;
}

.shop > img {
  margin-top: -8px;
}

.shop-img {
  width: 202px;
  max-height: 93px;
}

.shop-modal-trigger {
  cursor: pointer;
}

.censor {
  width: auto;
  height: 59px;
  bottom: 50px;
  left: 20px;
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.censor-img {
  width: 36px;
  height: 46px;
  padding-right: 10px;
}

.censor-img2 {
  width: 103px;
  height: 46px;
  padding-right: 3px;
}

.logo {
  width: auto;
  height: 30px;
  position: absolute;
  bottom: 65px;
  right: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
}

.logo-img {
  width: 101px;
  height: 30px;
}

.copyright-info {
  width: 100%;
  height: auto;
  color: #adaeb5;
  position: absolute;
  bottom: 25px;
  left: 20px;
  font-size: 15px;

  font-size: 14px;
  font-family: "MiSans-Medium";
}
</style>
